import { divider, line, text } from './Divider.css';

export function Divider({ text: label }: { text?: string }) {
  return (
    <div className={divider}>
      <span className={line} />
      {label && <span className={text}>{label}</span>}
      {label && <span className={line} />}
    </div>
  );
}
